<template>
    <div>
        <v-divider></v-divider>
        <v-card>
            <v-container class="filter-heading">
                <v-layout justify-space-between align-content-center>
                    <v-flex>
                        <h3 class="mt-3 red--text">{{ $t('Views.Settings.settings_title') }}</h3>
                    </v-flex>

                    <user-heading></user-heading>
                </v-layout>
            </v-container>
        </v-card>

        <v-layout justify-center wrap class="my-4">
            <v-flex xs12 md8>
                <material-card
                        color="red">
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm6 md4>
                                <v-chip color="default">{{user.username}}</v-chip>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-chip color="default">
                                    <span v-if="user.portalUser">{{ $t('Views.Settings.portal_user_label') }}</span>
                                    <span v-else>{{ $t('Views.Settings.pws_user_label') }}</span>
                                </v-chip>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                                <v-chip color="success" v-if="user.privacyAccepted">{{
                                    $t('Views.Settings.privacy_accepted_label') }}
                                </v-chip>
                                <v-chip color="error" v-else>{{ $t('Views.Settings.privacy_not_accepted_label') }}
                                </v-chip>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field :label="$t('Views.Settings.email_label') + '*'" required
                                              :value="user.email"
                                              v-model="user.email"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field :label="$t('Views.Settings.business_name_label') + '*'" required
                                              :value="user.businessName"
                                              v-model="user.businessName"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-select
                                        :items="langs"
                                        v-model="user.language"
                                        item-text="label"
                                        item-value="value"
                                        :label="$t('Views.Settings.language_label') + '*'"
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md6>
                                <v-text-field
                                        :append-icon="showPwd ? 'mdi-eye-off' : 'mdi-eye'"
                                        :type="showPwd ? 'text' : 'password'"
                                        v-model="newPassword"
                                        name="input-10-1"
                                        :label="$t('Views.Settings.change_password_label') + '*'"
                                        :hint="$t('Views.Settings.change_password_hint')"
                                        class="purple-input"
                                        counter
                                        @click:append="showPwd = !showPwd"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm8>
                                <v-select
                                        v-model="user.country"
                                        :items="countries"
                                        item-text="label"
                                        item-value="key"
                                        :label="$t('Views.Settings.country_label') + '*'"
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-text-field :label="$t('Views.Settings.zipcode_label') + '*'" required
                                              :value="user.zipcode"
                                              v-model="user.zipcode"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <small>*{{ $t('Views.Settings.required_fields_label') }}</small>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="mx-0 font-weight-light" color="success" @click="update">{{
                            $t('Views.Settings.update_button_label') }}
                        </v-btn>
                    </v-card-actions>
                </material-card>
            </v-flex>
            <v-snackbar
                    v-model="snackbar.show"
                    :color="snackbar.color"
                    :timeout="snackbar.timeout"
                    top>
                {{ snackbar.text }}
            </v-snackbar>
        </v-layout>

    </div>
</template>

<script>
    import i18n from '@/i18n'
    import httpService from '@/service/httpService'
    import {countries} from '@/json-common/countries'
    import userHeading from '@/components/core/UserHeading'

    export default {
        data() {
            return {
                user: {},
                newPassword: '',
                showPwd: false,
                langs: [
                    {label: 'Italiano', value: 'it_IT'},
                    {label: 'English', value: 'en_US'},
                    {label: 'Polski', value: 'pl_PL'},
                    {label: 'Deutsch', value: 'de_DE'},
                    {label: 'Spanish', value: 'es_ES'},
                    {label: 'Portuguese', value: 'pt_PT'}
                ],
                countries: countries,
                snackbar: {
                    show: false,
                    color: '',
                    timeout: 6000,
                    text: ''
                }
            }
        },
        components: {
            'user-heading': userHeading
        },
        created() {
            this.getUser()
        },
        methods: {
            getUser() {
                return httpService.get('/users/' + this.$store.getters.getProfile.username).then(user => {
                    this.user = user
                }).catch(error => {
                    console.error(error)
                })
            },
            update() {
                if (this.user.language && this.user.password && this.user.email) {
                    let _user = {email: this.user.email};
                    _user.language = this.user.language;
                    _user.businessName = this.user.businessName;
                    _user.country = this.user.country;
                    _user.zipcode = this.user.zipcode;
                    if (this.newPassword.length > 0) {
                        _user.password = this.newPassword;
                    }

                    httpService.patch('/users/' + this.user.username, _user)
                        .then(() => {
                            this.snackbar.text = this.$t('Views.Settings.user_update_success_message')
                            this.snackbar.color = 'success'
                            this.snackbar.show = true
                        })
                        .catch(error => {
                            console.error(error);
                            this.snackbar.text = this.$t('Views.Settings.user_update_error_message')
                            this.snackbar.color = 'error'
                            this.snackbar.show = true
                        })
                } else {
                    this.snackbar.text = this.$t('Views.Settings.user_update_fields_mandatory_message')
                    this.snackbar.color = 'error'
                    this.snackbar.show = true
                }
            }
        },
        watch: {
            'user.language'(locale) {
                this.$store.dispatch("ACTION_SET_LOCALE", locale)
                    .then(() => i18n.locale = this.locale.substr(0, 2))
                    .catch((error) => {
                        console.error('Error during locale update', error);
                    })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
